export const ENV = "PRODUCTION";
// export const ENV = "DEVELOPMENT";

export const API_URL = "https://api.eliqx.io/api";
// export const API_URL = "https://api.auction.top-developer.net/api";
// export const API_URL = "http://127.0.0.1:8000/api";

export const APPLE_API_KEY = "0466c5aa8c973cf6d4d917c0f8fdfe56efaab8e6";
